import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { PassengerCreationResponse } from '../Models/BookingPassengerTicketIssuanceProperties';
import { RateOfExchangeProperties } from '../Models/RateOfExchangeProperties';

@Injectable({
  providedIn: 'root'
})
export class RateOfExchangeService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  ROEGetAlls(): Observable<RateOfExchangeProperties[]> {
    return this.http.get<RateOfExchangeProperties[]>(this.baseUrl + '/RateOfExchange/ROEGetAlls').pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }
  GetRateOFExchangeByID(id,agencyid): Observable<RateOfExchangeProperties> {
    return this.http.get<RateOfExchangeProperties>(this.baseUrl + '/RateOfExchange/GetRateOFExchangeByID/' + id + '/' + agencyid).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }
  CreateRateOfExchange(newobj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/RateOfExchange/CreateRateOfExchange', newobj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateRateOfExchange(Obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/RateOfExchange/UpdateRateOfExchange', Obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  DeleteByIdROE(userObj, userid): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/RateOfExchange/DeleteByIdROE/' + userObj + '/' + userid, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

}
